import React from 'react';
import Notes from './Notes.jsx';

const JobNotesIndex = () => {
    return (
        <div>
            <Notes context={"job"} />
        </div>
    );
}

export default JobNotesIndex;